import generateClassNames from '@/utils/generate-class-names'
import clsx from 'clsx'
import { forwardRef } from 'react'
import './form-error-message.scss'

const classes = generateClassNames('form-error-message', [])

export interface FormErrorMessageProps
  extends React.HTMLAttributes<HTMLDivElement> {}

const FormErrorMessage = forwardRef(function FormErrorMessage(
  props: FormErrorMessageProps,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { children, className, ...other } = props

  return (
    <div
      ref={ref}
      className={clsx(classes.root, className)}
      role='alert'
      {...other}
    >
      {children}
    </div>
  )
})

export default FormErrorMessage
